export default "__VITE_ASSET__mhc90nIx__"